import { render } from "./Terms.vue?vue&type=template&id=54c9ce0f&scoped=true&bindings={}"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=54c9ce0f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-54c9ce0f"

export default script